GP.GPMod('Modal',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;
    // position of myaccount dropdown container
    var navbar_controls_pos = 250;

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util  = self.app.Util;
            _log   = self.app.Util.log;
        },
        api_defaults: {
            modal: true
        },
        modal_defaults: {
            // modalOverflow: true,
            backdrop:      true,
            keyboard:      true
        },
        event_namespace:     'bs-modal',

        modal_id: '#fl-modal',
        $modal: null,
        modal_close_timer: null,

        on_open_cb: null,

        // form fields pending validation that should prevent form submission
        validation_pending: {},

        // callback after validating
        validate_cb: null,

        // properties to filter out from input for api call to get modal
        filter_props: ['thread_json'],

        // reset object of pending fields still awaiting validation
        reset_validation_pending: function() {
            _data.validation_pending = {};
        }
    };

    var gui = {
        add_modal_class: function(class_name) {
            if (_data.$modal) {
                _data.$modal.addClass(class_name);
            }
        },
        remove_modal_class: function(class_name) {
            if (_data.$modal) {
                _data.$modal.removeClass(class_name);
            }
        }
    };


    var apis = {
        get_modal: function(input) {
            // copy the input obj so we can preserve it in the modal's data
            var original_input = $.extend(true, {}, input);

            var url;
            if (input.hasOwnProperty('url')) {
                url = input.url;
                delete input.url;
            } else if (input.hasOwnProperty('href')) {
                url = input.href;
                delete input.href;
            } else {
                // no url, GTFO
                return;
            }

            // remove any unneeded properties from the input object
            // since they do not need to be sent in the ajax request
            _data.filter_props.forEach(function(prop) {
                if (input.hasOwnProperty(prop)) {
                    delete input[prop];
                }
            });

            self.api.json(url, {
                data:    $.extend({}, _data.api_defaults, input),
                error:   function() {},
                success: function(json) {
                    handlers.display_modal(json, original_input);
                }
            });
        },
        validate: function(field_name, value) {
            self.api.json('/members/user/validate_data/', {
                data: {
                    field: field_name,
                    value: encodeURIComponent(value)
                },
                error: function() {},
                success: handlers.validation_result
            });
        },
        form_submit: function(form) {
            var $form  = $(form);
            var url    = $form.attr('action');
            var method = $form.attr('method');
                method = _util.check_obj(method) ? method : 'GET';

            self.api.json(url, {
                type:    method.toUpperCase(),
                data:    $form.serialize(),
                error:   function() {},
                success: function(json) {
                    if (typeof json != 'undefined') {
                        if (_util.check_obj(json.errors)) {
                            var $btn = $("#bs-modal-submit");
                            var btn_text = $btn.data('button-text');

                            handlers.show_errors(json.errors);

                            $btn.text(btn_text).toggleClass('disabled');
                            return;
                        }

                        // a/b test
                        if (json.hasOwnProperty('redirect')) {
                            window.location.replace(json.redirect);
                        }

                        if (json.hasOwnProperty('reload')) {
                            window.location.reload(true);
                        }

                        // check if the callback for the form submission is supposed to result in another modal
                        if (_util.check_obj(json.replace_modal) && _util.check_obj(json.html)) {
                            _data.$modal.find('.modal-content').html(json.html);
                            return;
                        }
                        if (json.hasOwnProperty('username')) {
                            $('#profile_preview a .username').text(json.username);
                        }

                        if (json.hasOwnProperty('msg_prefs_updated')) {
                            // reset msg overlay to use new msg pref settings
                            // MessagingApp.reset();
                        }
                    }

                    $("#bs-modal-submit").text('Done!');
                    events.close();
                }
            });
        }
    };


    var events = {
        init: function() {
            // setup event listener for Modal:open
            vent.on(self.moduleName+":open", this.open, this);

            // setup event listener for Modal:open:static
            vent.on(self.moduleName+":open:static", this.open_static, this);

            // setup event listener for Modal:open:confirm
            vent.on(self.moduleName+":open:confirm", this.open_confirm, this);

            // setup event listener for Modal:open:alert
            vent.on(self.moduleName+":open:alert", this.open_alert, this);

            // close modals when requested or when a page navigation occurs
            vent.on(self.moduleName+":close Page:redirect", this.close, this);

            vent.on(self.moduleName+":add_class", gui.add_modal_class, this);
            vent.on(self.moduleName+":remove_class", gui.remove_modal_class, this);

            vent.on(self.moduleName+":trigger_validate_username", handlers.trigger_validate_username, this);

            // custom grey checkmark
            $(document).on('click.' + _data.event_namespace, 'label.checkbox input[type="checkbox"]', handlers.grey_checkmark);

            // form submission handler
            $(document).on('submit.' + _data.event_namespace, _data.modal_id+" .modal-form", handlers.submit_handler);

            // hook up submit button to modal-form submit()
            $(document).on("click." + _data.event_namespace, "#bs-modal-submit", handlers.submit_button);

            // username ajax live validation
            $(document).on("focus." + _data.event_namespace, _data.modal_id+" input#username", handlers.start_validate_username);
            $(document).on("blur." + _data.event_namespace, _data.modal_id+" input#username", handlers.validate_username);

            // flirt modal button binds
            $(document).on("click." + _data.event_namespace, "a.flirt-match-send", handlers.add_flirt);

            // toggle terms and conditions
            $(document).on("click." + _data.event_namespace, "#terms-toggle", handlers.toggle_terms);

            // expose this function at the app level to return the modal, or a blank jquery obj
            self.get_modal = function() {
                return (_data.$modal ? _data.$modal : $());
            };
        },
        return_modal: function() {
            return _data.$modal;
        },
        open: function(obj, $clicked, cb) {
            _data.reset_validation_pending();

            if (_util.check_obj(obj)) {
                // Don't show slideshow on profile page for mobile users
                // if (_util.check_obj(obj.slideshow) && obj.slideshow == 'profile') {
                //     if ($('html').hasClass('mobile')) {
                //         return;
                //     }
                // }
                // add a spinner while ajax loads the modal if requested
                if (obj.spinner && $clicked) {
                    var $spinner = $('<div/>').addClass('modal-loading').html($('<div/>').addClass('spinner-container'));
                    $clicked.addClass('modal-spinner')
                        .find('.js-spinner-wrap').prepend($spinner)
                        .find(".spinner-container").spin("large");
                }

                if (obj.position) {
                    _data.position = obj.position;
                }
            }

            // trigger callback function if one was provided
            if (typeof cb == 'function') {
                _data.on_open_cb = cb;
            }

            // grab the modal via ajax and open
            apis.get_modal(obj);
        },
        open_static: function(obj) {
            _data.reset_validation_pending();

            if (_util.check_obj(obj)) {
                // passing in an id of a div to use for content for the modal,
                // instead of a obj.modal_div dom/jquery object
                if (_util.check_obj(obj.modal_div_id) && !_util.check_obj(obj.modal_div)) {
                    obj.modal_div = $(obj.modal_div_id);
                }
                if (_util.check_obj(obj.modal_div)) {
                    if (_util.check_callable(obj.shown)) {
                        obj.modal_div.on('shown.bs.modal', $.proxy(obj.shown, self));
                    }
                    handlers.set_scrollbar();

                    // store a reference to our modal
                    _data.$modal = obj.modal_div;

                    var modal_options = {};

                    // either use the obj.modal_options if passed in, or check for individual data-* from a click event
                    if (_util.check_obj(obj.modal_options)) {
                        modal_options = obj.modal_options;
                    } else {
                        if (_util.check_obj(obj.backdrop)) {
                            modal_options.backdrop = obj.backdrop;
                        }
                        if (_util.check_obj(obj.keyboard)) {
                            modal_options.keyboard = obj.keyboard;
                        }
                    }

                    // setup our modal options, and display the modal
                    var options = $.extend({}, _data.modal_defaults, modal_options);
                    _data.$modal.modal(options);

                    // check if there are hide/hidden properties of the passed in object
                    // then see if they are callable, or set to "default"
                    if (_util.check_obj(obj.hide)) {
                        if (_util.check_callable(obj.hide)) {
                            obj.modal_div.on('hide.bs.modal', $.proxy(obj.hide, self));
                        } else if (obj.hide == 'default') {
                            obj.modal_div.on('hide.bs.modal', handlers.modal_hide);
                        }
                    }
                    if (_util.check_obj(obj.hidden)) {
                        if (_util.check_callable(obj.hidden)) {
                            obj.modal_div.on('hidden.bs.modal', $.proxy(obj.hidden, self));
                        } else if (obj.hidden == 'default') {
                            obj.modal_div.on('hidden.bs.modal', handlers.modal_hidden);
                        }
                    }
                }
            }
        },
        // get the confirm modal (replacement for JS confirm())
        open_confirm: function(obj, confirm_callback, cancel_callback) {
            // console.trace('Modal.open_confirm() called obj: ', obj);
            obj = obj || {};
            obj.template = obj.template || 'DEFAULT';
            if (obj.override_confirm && _util.check_callable(confirm_callback)) {
                confirm_callback.call(this);
                return;
            }

            var close_delay = obj.close_delay ? obj.close_delay : null;

            $.ajax({
                url: '/members/util/confirm_modal/',
                type: 'get',
                data: $.extend({}, _data.api_defaults, obj),
                success: function(json) {
                    // remove any existing modal
                    events.close();

                    if (_util.check_obj(json.html)) {
                        // insert the modal into the dom, as a child of the body element
                        $('body').append(json.html);

                        // store a reference to our modal
                        _data.$modal = $(_data.modal_id);

                        var options = $.extend({}, _data.modal_defaults, obj);
                        _data.$modal.modal(options);

                        vent.trigger("Page:push_state", {modal:true});
                        _data.$modal.on('hide.bs.modal', handlers.modal_hide);
                        _data.$modal.on('hidden.bs.modal', handlers.modal_hidden);

                        $('.fling-modal button.confirm-ok').one('click', function() {
                            if (_util.check_callable(confirm_callback)) {
                                confirm_callback.call(this);
                            }
                            events.close(close_delay);
                        });

                        $('.fling-modal button.confirm-cancel').one('click', function() {
                            events.close();

                            if (_util.check_callable(cancel_callback)) {
                                cancel_callback.call(this);
                            }
                        });
                    }
                }
            });
        },
        // get the alert modal (replacement for JS alert())
        open_alert: function(obj) {
            obj = obj || {};
            obj.template = obj.template || '';

            self.api.json('/members/util/alert_modal/', {
                data:    $.extend({}, _data.api_defaults, obj),
                error:   function() {},
                success: function(json) {
                    handlers.display_modal(json, obj);
                }
            });
        },
        close: function(delay) {
            // console.trace('Modal.close() called with delay: ' + delay);

            var delay_parsed = parseInt(delay, 10);
            if (_data.modal_close_timer) {
                clearTimeout(_data.modal_close_timer);
            }
            // close whatever modal(s) may be open, if they exist
            if (_data && _data.$modal) {
                if (_.isFinite(delay_parsed)) {
                    _data.modal_close_timer = setTimeout(function() {
                        if (_data && _data.$modal) {
                            _data.$modal.modal('hide');
                        }
                    }, delay_parsed);
                } else {
                    _data.$modal.modal('hide');
                }
            }
        },
        setup_arrow_key_nav: function() {
            $(function() {
                $(document).on('keydown.' + _data.event_namespace, function(e) {
                    var href;
                    if (e.which == 37) { // left
                        $(_data.modal_id + ' a.media-prev').trigger('click');
                    }
                    else if (e.which == 39) { // right
                        $(_data.modal_id + ' a.media-next').trigger('click');
                    }
                });
            });
        }
    };


    var handlers = {
        // callback that fires when we receive the modal back from the api and displays it
        display_modal: function(json, input) {
            // remove any existing modal
            events.close();

            // make sure we remove any spinners
            $('.modal-spinner').removeClass('modal-spinner').find('.loading').remove();

            // redirect if we have a reason to
            if (_util.check_obj(json.redirect)) {
                top.location.href = json.redirect;
                return;
            }
            if (_util.check_obj(json.html)) {
                handlers.set_scrollbar();

                // insert the modal into the dom, as a child of the body element
                $('body').append(json.html);

                // store a reference to our modal
                _data.$modal = $(_data.modal_id);

                _data.$modal.original_input = input;

                if (_data.$modal.hasClass('modal-media-video') ||
                _data.$modal.hasClass('modal-media-picture') ||
                _data.$modal.hasClass('modal-user-profile') ||
                _data.$modal.hasClass('modal-content-viewer')) {
                    _data.scrollPosY = window.scrollY;
                }

                if (input.auto_trigger) {
                    _data.$modal.data('auto_trigger', true);
                }

                // setup event for when modal is shown/rendered
                _data.$modal.on('shown.bs.modal', handlers.modal_shown);

                // setup our modal options, and display the modal
                var options = $.extend({}, _data.modal_defaults, input);
                _data.$modal.modal(options);
                if (options.modalclasses) {
                    _data.$modal.addClass(options.modalclasses);
                }

                // triggered when modal hide method has been called
                _data.$modal.on('hide.bs.modal', handlers.modal_hide);

                // triggered when modal is hidden.  We are empty here to cleanup event handlers
                _data.$modal.on('hidden.bs.modal', handlers.modal_hidden);
            }
        },
        // callback that fires when the modal is rendered
        modal_shown: function(e) {
            $('.fling-modal label.ic input').iCheck({
                handle: 'checkbox',
                checkboxClass: 'icheckbox_minimal-blue'
            });
            // setup modals that can upload profile pic (with webcam upload, etc...)
            if (_data.$modal.hasClass('js-has-profile-pic-upload')) {
                _data.$modal.data('has_pic_upload', true);
                vent.trigger("PicUpload:setup_profile_pic_upload_modal");

                // name, value, expire_days
                _util.set_cookie('fl_pic_upload_shown', 1, 1);
            }
            // setup modals that are meant to upload gallery pics/videos
            if (_data.$modal.hasClass('js-has-gallery-pic-upload')) {
                _data.$modal.data('has_pic_upload', true);
                vent.trigger("PicUpload:setup_gallery_upload_modal");
            }
            // setup modals that are meant to upload pics/videos for chat
            if (_data.$modal.hasClass('js-has-chat-upload')) {
                _data.$modal.data('has_pic_upload', true);
                vent.trigger("PicUpload:setup_chat_upload_modal");
            }
            // setup mobile footer modal that are meant to upload image/video/posts
            if (_data.$modal.hasClass('js-has-mobile-post-upload')) {
                _data.$modal.data('has_pic_upload', true);
                vent.trigger("PicUpload:setup_mobile_post_upload_modal");
            }
            if (MoshPit.get_size() != 'mobile') {
                if (_data.$modal.hasClass('modal-media-video')) {
                    vent.trigger('Video:setup');
                }
            }
            if (_data.$modal.hasClass('js-trigger-finish-profile')) {
                _data.$modal.data('finish_profile', true);
            }
            if (_data.$modal.hasClass('js-can-rate')) {
                _data.$modal.data('can_rate', true);
                vent.trigger("picrating:setup", _data.$modal);
            }
            if (_data.$modal.hasClass('js-arrow-key-nav')) {
                events.setup_arrow_key_nav();
            }
            if (_data.$modal.hasClass('js-show-hotties')) {
                vent.trigger("hotties:setup_hotties_modal");
            }

            // previously the likers modal setup, but now a generic user-list modal
            if (_data.$modal.hasClass('js-user-list')) {
                vent.trigger("User:setup_user_list_modal", _data.$modal.original_input.id);
            }

            if (_data.$modal.hasClass('js-content-viewer')) {
                vent.trigger("ContentViewer:setup_viewer", _data.$modal.original_input.content_id);
            }


            // check for js-* classes to setup premium upload/viewer modals
            if (_data.$modal.hasClass('js-premium-viewer')) {
                vent.trigger("PremiumViewer:setup_viewer");
            }
            if (_data.$modal.hasClass('js-premium-upload')) {
                vent.trigger("Premium:setup_upload");
            }
            if (_data.$modal.hasClass('js-premium-change-price')) {
                vent.trigger("PremiumChangePrice:setup_viewer");
            }

            if (_data.$modal.hasClass('js-ice-breaker')) {
                vent.trigger("User:setup_ice_breaker", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-gdpr-remove')) {
                vent.trigger("EditAccount:setup_gdpr_remove_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-user-interest')) {
                vent.trigger("User:setup_user_interest", _data.$modal);
            }

            if (_data.$modal.hasClass('modal-media-video') ||
                _data.$modal.hasClass('modal-media-picture') ||
                _data.$modal.hasClass('modal-user-profile') ||
                _data.$modal.hasClass('modal-content-viewer')) {
                    $('body').addClass('media-modal-shown');
                    _data.$modal.data('media-modal', true);
            }

            // write cookie for flirt modals
            if (_data.$modal.hasClass('js-flirt-sequence')) {
                // write necessary cookies to not show modal again, until it's time
                _util.set_cookie('fl_flirt_shown', 1, 1);
                _util.set_cookie('next_sequence',  1, 1);
            }

            // add microstate for modal open if it wasn't automatically triggered
            if (!_data.$modal.data('auto_trigger') /* && !_data.$modal.hasClass('js-no-state') */) {
                if (window.history && window.history.pushState) {
                    if (!window.history.state || !window.history.state.hasOwnProperty('modal')) {
                        // add content_id / duid if content modal is triggered
                        if (_data.$modal.hasClass('js-content-viewer')) {
                            vent.trigger("Page:push_state", {
                                modal: true,
                                content_viewer: true,
                                content_id: viewer_content.content_id,
                                duid: viewer_content.duid
                            });
                        } else {
                            vent.trigger("Page:push_state", {modal:true});
                        }
                    }
                }
            }

            // custom body class for flirt modal
            if (_data.$modal.hasClass('modal-user-flirt')) {
                $('body').addClass('user-flirt-modal-shown');
                _data.$modal.data('flirt-modal', true);
            }

            if (_data.$modal.hasClass('js-get-on-top')) {
                vent.trigger("TopOfSearch:setup_get_on_top_modal");
            }

            if (_data.$modal.hasClass('js-daily-spotlight')) {
                vent.trigger("DailySpotlight:setup_modal");
            }

            if (_data.$modal.hasClass('js-stealth-mode')) {
                vent.trigger("StealthMode:setup_modal");
            }

            if (_data.$modal.hasClass('js-read-status')) {
                vent.trigger("ReadStatus:setup_modal");
            }

            if (_data.$modal.hasClass('js-confirm-email')) {
                vent.trigger("User:setup_confirm_email_modal");
            }

            if (_data.$modal.hasClass('js-post-reg')) {
                _data.$modal.data('has_pic_upload', true);
                // vent.trigger("PostRegistration:setup_pic_upload");
                vent.trigger("PostRegistration:setup_modal");
            }

            if (_data.$modal.hasClass('profile-mini-modal') && _data.hasOwnProperty("position") && !GP.sdata.is_mobile && !GP.sdata.is_tablet) {
                _data.$modal.css({
                    left: _data.position.left
                });
            }

            if (_data.$modal.hasClass('js-hotpick-filters')) {
                vent.trigger("HotPickFilters:setup_hotpick_filters_modal");
            }

            if (_data.$modal.hasClass('js-content-rating')) {
                vent.trigger("User:setup_content_rating_modal");
            }

            if (_data.$modal.hasClass('js-message-hint-pref')) {
                vent.trigger("EditAccount:setup_msg_hint_pref_modal");
            }

            if (_data.$modal.hasClass('js-trial-upgrade')) {
                vent.trigger("TrialUpgrade:setup_trial_upgrade_modal");
            }

            if (_data.$modal.hasClass('js-oneclick-upgrade')) {
                vent.trigger("OneClickUpgrade:setup_oneclick_upgrade_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-unlock-explicit-content-modal')) {
                vent.trigger("Unlock:setup_explicit_modal", _data.$modal.original_input);
            }


            if (_data.$modal.hasClass('js-unlock-premium-users-toggle-modal')) {
                vent.trigger("Unlock:setup_premium_toggle_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-unlock-thread-modal')) {
                vent.trigger("Unlock:setup_thread_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-unlock-fr-modal')) {
                vent.trigger("Unlock:setup_friend_request_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('js-choose-interests-modal')) {
                vent.trigger("Profile:setup_choose_interests_modal", _data.$modal.original_input);
            }

            if (_data.$modal.hasClass('modal-choose-interests-search')) {
                vent.trigger("Search:setup_choose_interests_modal", _data.$modal.original_input);
            }

            if (typeof _data.on_open_cb == 'function') {
                _data.on_open_cb();
            }

            // $(document).on('click', '[data-dismiss="modal"]', handlers.close_button_click);
        },
        // callback that is fired immediately when the hide instance method has been called.
        modal_hide: function(e) {
            handlers.reset_scrollbar();
            // $('.close-mobile').remove();
            if (_data.$modal.data('media-modal') === true) {
                $('body').removeClass('media-modal-shown');
                if (_data.scrollPosY) {
                    window.scroll(0, _data.scrollPosY);
                }
            }

            if (_data.$modal.data('flirt-modal') === true) {
                $('body').removeClass('user-flirt-modal-shown');
            }

            // pass in bypass_vjs_close when calling Modal:open to bypass calling Video:close event (killing videojs players)
            var od = (typeof _data.$modal.original_input == 'object' && _data.$modal.original_input)
                       ? _data.$modal.original_input
                       : {};

            // call Video:close unless explicitly overridden
            if (!od.hasOwnProperty('bypass_vjs_close') || od.bypass_vjs_close !== true) {
                vent.trigger("Video:close");
            }
        },
        // callback that is fired when the modal is closed/hidden... we will remove it completely
        modal_hidden: function(e) {
            if (_data.$modal.data('has_pic_upload') === true) {
                vent.trigger("PicUpload:cleanup");
            }
            // cleanup finish profile modal if needed and send along necessary data before closing
            if (_data.$modal.data('finish_profile') === true) {
                var num_left = $('.fling-modal #prof_game_num_left').text();
                vent.trigger("user:finish_profile:cleanup", num_left);
            }

            if (_data.$modal.hasClass('js-content-viewer')) {
                vent.trigger('ContentViewerLayout:destroy_modal');
            }

            if (_data.$modal.hasClass('js-stealth-mode')) {
                if (!GP.sdata.my_user.stealth_mode) {
                    vent.trigger('StealthMode:cancel_stealth_mode');
                }
            }

            // let's clear this out no matter what
            _data.$modal.remove();
            _data.$modal = null;
            _data.on_open_cb = null;

            // broadcast custom jquery event that the modal closed incase another modal is waiting to open
            $(document).trigger('fl_modal_closed');
        },
        show_errors: function(errors) {
            // no errors, so gtfo
            if (!_util.check_obj(errors)) {
                return;
            }

            var $error_container = $('.modal .error_container');
            $error_container.find('p').remove();

            $.each(errors, function(i,val) {
                $error_container.append('<p class="error">'+val+'</p>');
            });
            $error_container.show();
        },
        grey_checkmark: function(e) {
            var $checkbox     = $(this);
            var $label        = $checkbox.parent('label');
            var add_or_remove = $checkbox.is(":checked") ? true : false;

            $label.toggleClass('checked', add_or_remove);
        },
        submit_button: function(e) {
            e.preventDefault();

            if ($.isEmptyObject(_data.validation_pending) === true) {
                if (!$(this).hasClass('disabled')) {
                    $("form.modal-form").submit();
                }
            }
        },
        submit_handler: function(e) {
            e.preventDefault();
            var form_submit_url = $(this).attr('action') || '';

            if (form_submit_url.length > 0) {
                $("#bs-modal-submit").text('Saving...').toggleClass('disabled');

                apis.form_submit(this);
            }
        },
        start_validate_username: function(e) {
            // set variable to indicate we're validating username
            _data.validation_pending.username = true;
        },
        trigger_validate_username: function(cb) {
            // store callback function if one was provided
            if (typeof cb == 'function') {
                _data.validate_cb = cb;
            }

            $(_data.modal_id+" input#username").focus().blur();
        },
        validate_username: function(e) {
            var name, value;
            var $el = $(this);

            value = $el.val();
            name  = $el.attr('name');

            if (name === 'username' && value === _modal_vars.existing_username) {
                // remove validation_pending property for username if it wasn't changed
                delete _data.validation_pending.username;
                handlers.display_error(name);
                if (typeof _data.validate_cb == 'function') {
                    _data.validate_cb();
                    _data.validate_cb = null;
                }
                return;
            }
            if (name === 'username' && !_util.check_obj(value)) {
                handlers.display_error(name, 'Username cannot be empty');
                return;
            }


            var state_img = $('#validate_' + name + '_img');
            if (!_util.check_obj(value)) {
                if (_util.check_obj(state_img)) {
                    state_img.css('display', 'none');
                }
                return;
            }


            if (_util.check_obj(state_img)) {
                state_img.css('display', 'inline');
                state_img.attr('src', _modal_vars.loading_gif);

                apis.validate('username', value);
            }
        },
        validation_result: function(rval) {
            // validation success
            if (typeof rval != 'undefined' && rval.hasOwnProperty('field') && !rval.hasOwnProperty('error')) {
                handlers.display_error(rval.field);

                // check for callback
                if (typeof _data.validate_cb == 'function') {
                    _data.validate_cb();
                    _data.validate_cb = null;
                }
                return;
            }

            // show errors
            if (typeof rval != 'undefined' && rval.hasOwnProperty('field') && rval.hasOwnProperty('error')) {
                handlers.display_error(rval.field, rval.error);
            }
        },
        display_error: function(field, msg) {
            var txt_div     = $('#validate_' + field + '_text');
            var state_img   = $('#validate_' + field + '_img');
            var idiv        = $('#validate_' + field + '_div');
            var input_field = $('#' + field);

            if (!_util.check_obj(txt_div) || !_util.check_obj(state_img) || !_util.check_obj(idiv)) {
                return;
            }

            if (_util.check_obj(msg)) {
                state_img.css('display', 'none');
                txt_div.html(msg);
                idiv.css('display', 'flex');
            } else {
                state_img.css('display', 'none');
                idiv.css('display', 'none');
                state_img.css('display', 'inline');
                state_img.attr('src', _modal_vars.checkmark_gif);

                // remove field from validation_pending object so form submission won't be prevented
                if (_data.validation_pending.hasOwnProperty(field)) {
                    delete _data.validation_pending[field];
                }
            }
        },
        set_scrollbar: function() {
            var scrollbar_width = 0;

            if (document.body.clientWidth >= window.innerWidth) {
                return;
            }

            scrollbar_width = scrollbar_width || handlers.measure_scrollbar();
            if (scrollbar_width) {
                $('#header-inner').css('margin-right', scrollbar_width);
                $('#activity-feed-wrap').css('margin-right', scrollbar_width);
                $('#right-drawer-tabs').css('right', scrollbar_width);
                $('#right-drawer').css('right', scrollbar_width);
                $('#header ul#navbar-controls').css('right', (navbar_controls_pos + scrollbar_width));
            }
        },
        measure_scrollbar: function() {
            // From bootstrap 3.2
            var scrollDiv = document.createElement('div');
            var $fl_body = $('body');
            scrollDiv.className = 'modal-scrollbar-measure';
            $fl_body.append(scrollDiv);
            var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            $fl_body[0].removeChild(scrollDiv);
            return scrollbarWidth;
        },
        reset_scrollbar: function() {
            $('#header-inner').css('margin-right', '');
            $('#activity-feed-wrap').css('margin-right', '');
            $('#right-drawer-tabs').css('right', '');
            $('#right-drawer').css('right', '');
            $('#header ul#navbar-controls').css('right', navbar_controls_pos);
        },
        add_flirt: function(e) {
            e.stopImmediatePropagation();
            var flirt_action = $(this).data('action');

            // temp for logging
            var loc_path = window.location.pathname.split('/');
            var qs_path = window.location.search;
            var cur_page = '';
            if (loc_path.length < 3) {
                // old school url /main.php?a=something.something...
                var qs = qs_path.match(/a=\w+\.(\w+)/i);
                if (qs && qs.length > 1) {
                    cur_page = qs[1];
                }
            } else {
                cur_page =  loc_path[2].toLowerCase();
            }

            if (flirt_action == 'yes') {
                if (cur_page == 'search') {
                    $.post('/members/user/add_flirt/', {'flirt_type': 1, 'from_search': 1});
                } else {
                    $.post('/members/user/add_flirt/', {'flirt_type': 1});
                }
            } else {
                if (cur_page == 'search') {
                    $.post('/members/user/add_flirt/', {'flirt_type': 2, 'from_search': 1});
                } else {
                    $.post('/members/user/add_flirt/', {'flirt_type': 2});
                }
            }

            $('.flirt-match-btn').remove();
            events.close();
            return false;
        },
        toggle_terms: function() {
            $('#terms-container').toggle();
            if ($('#terms-container').is(':hidden')) {
                $('#terms-pointer').html('&#9658;');
            } else {
                $('#terms-pointer').html('&#9660;');
            }
        },
        close_button_click: function(e) {
            if (
                $(this).hasClass('close')
                && window.history
                && window.history.state
                && window.history.state.modal
            ) {
                window.history.back();
            }
        }
    };

    this.addInitializer(function() {
        _data.init();
        events.init();

        // expose handlers and events at the module level
        self.handlers = handlers;
        self.events   = events;
    });
});


